import { AccountType } from "@common/constants/domains/accounting/accounts";
import {
    ScheduleTransactionMode,
    canScheduleTransaction,
} from "@common/helpers/domains/accounting/scheduleTransactionFit";
import { ScheduleType } from "@common/types/domains/accounting/schedule";

export const TRANSACTION_TEMPLATE_BLOCK_REASONS = {
    expensesUnavailable: "Expense schedules aren't available yet",
} as const;

export function getTransactionTemplateBlockReason(options: {
    template: ScheduleTransactionMode;
    isExpensesEnabled: boolean;
}): string | null {
    const { template } = options;
    return template.type === ScheduleType.expense && !options.isExpensesEnabled
        ? TRANSACTION_TEMPLATE_BLOCK_REASONS.expensesUnavailable
        : null;
}

/** The policies one transaction's Schedule picker offers. */
export function filterTemplatesForTransaction<
    TTemplate extends ScheduleTransactionMode,
>(options: {
    templates: TTemplate[];
    amount: number;
    accountType: AccountType | null;
    isExpensesEnabled: boolean;
}): TTemplate[] {
    return options.templates.filter(
        (template) =>
            getTransactionTemplateBlockReason({
                template,
                isExpensesEnabled: options.isExpensesEnabled,
            }) === null &&
            canScheduleTransaction({
                mode: template,
                amount: options.amount,
                accountType: options.accountType,
            }),
    );
}
